'use client';

import {FRONTEND_URL} from 'config';
import {usePathname} from 'next/navigation';

interface CoderUpsellBannerProps {
  onShare: () => void;
}

// Shown on guide content sections when a Coder user has exceeded their 3
// claimed guides. Not a hard gate — content is still visible but we nudge
// them toward Premium or experience submission.
export function CoderUpsellBanner({onShare}: CoderUpsellBannerProps) {
  const pathname = usePathname();
  const pricingHref = `${FRONTEND_URL}/pricing?next=${encodeURIComponent(pathname)}`;

  return (
    <div className='mb-6 rounded-lg border border-iq-orange bg-iq-orange-light px-4 py-3 flex flex-wrap items-center justify-between gap-3'>
      <p className='text-sm font-medium text-iq-grey-dark'>
        Unlock all interview guides with Premium
      </p>
      <div className='flex items-center gap-2 shrink-0'>
        <button
          onClick={onShare}
          className='text-sm font-semibold text-iq-orange hover:text-iq-orange-dark transition-colors'>
          Share experience
        </button>
        <a
          href={pricingHref}
          className='px-3 py-1.5 bg-iq-orange text-white text-xs font-semibold rounded-md hover:opacity-90 transition-opacity'>
          Upgrade
        </a>
      </div>
    </div>
  );
}
